(() => {

    function initVideoPlayers(container = document) {

        container.querySelectorAll('.video-player').forEach(player => {

            if (player.dataset.initialized === 'true') return;
            player.dataset.initialized = 'true';

            const video = player.querySelector('video');
            const playButton = player.querySelector('.video-player__play');
            const muteButton = player.querySelector('.video-player__mute');

            if (!video || !playButton || !muteButton) return;

            function update() {

                // Playing state
                playButton.classList.toggle('is-playing', !video.paused);

                playButton.setAttribute(
                    'aria-label',
                    video.paused ? 'Play video' : 'Pause video'
                );

                // Muted state
                muteButton.classList.toggle('is-muted', video.muted);

                muteButton.setAttribute(
                    'aria-label',
                    video.muted ? 'Unmute video' : 'Mute video'
                );

            }

            playButton.addEventListener('click', async () => {

                if (video.paused) {
                    try {
                        await video.play();
                    } catch (e) {}
                } else {
                    video.pause();
                }

                update();

            });

            muteButton.addEventListener('click', () => {

                video.muted = !video.muted;

                update();

            });

            video.addEventListener('play', update);
            video.addEventListener('pause', update);
            video.addEventListener('volumechange', update);
            video.addEventListener('ended', update);

            update();

        });

    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initVideoPlayers());
    } else {
        initVideoPlayers();
    }

    document.addEventListener('shopify:section:load', e => {
        initVideoPlayers(e.target);
    });

    document.addEventListener('shopify:block:select', e => {
        initVideoPlayers(e.target);
    });

})();